module.exports = __webpack_public_path__ + "static/media/ship-bg-mobile-seawind.cad3ebf5.jpg";